module.exports = __webpack_public_path__ + "static/media/toggle-close.15a8bca0.svg";